import React from 'react';

import { useOrgUserService, OrgUserContext } from '@/controllers';
import { FCC } from '@/utils/types';

const OrgUserProvider: FCC = ({ children }) => {
  const state = useOrgUserService();

  return <OrgUserContext.Provider value={state}>{children}</OrgUserContext.Provider>;
};

export default OrgUserProvider;
